import { decideGeneralName, PlanNames } from "../components/Plans";

const GUARD_PREFIX = "sum_conv_tracked_";

type SubscriptionConversionInput = {
  planName: string;
  entityId: string;
  isNewSignup?: boolean;
  value?: number;
  currency?: string;
  externalId?: string;
};

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function trackSubscriptionConversion(
  input: SubscriptionConversionInput
): void {
  try {
    if (typeof window === "undefined") return;
    const { planName, entityId, isNewSignup, value, currency, externalId } =
      input;
    if (!planName || !entityId) return;

    const planGeneral = decideGeneralName(planName as PlanNames);
    if (!planGeneral || planGeneral === "UNKNOWN") return;

    const transactionId = `sub_${entityId}_${planName}`;

    const guardKey = `${GUARD_PREFIX}${transactionId}`;
    if (window.localStorage && window.localStorage.getItem(guardKey)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "subscription_complete",
      plan: planGeneral,
      plan_name: planName,
      value: typeof value === "number" ? value : undefined,
      currency: currency || undefined,
      transaction_id: transactionId,
      external_id: externalId || undefined,
      new_signup: !!isNewSignup,
    });

    if (window.localStorage) window.localStorage.setItem(guardKey, "1");
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("trackSubscriptionConversion failed", e);
  }
}

export function trackPanelView(): void {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "panel_view" });
  } catch (e) {
    console.warn("trackPanelView failed", e);
  }
}
